import { TAB_PROPS, ORIGIN_FIELDS, FIELD_PROPS, INNER_FIELD_PROPS } from '../constants'
import { mergeFields } from './merge-configs'
import { cloneDeep } from 'lodash'

const TABLES_PROPS = {
  TABLES: 'tables',
  FORM_FIELDS: 'form-fields',
  OPTION: 'option',
  COLUMNS: 'columns',
}

const FORM_PROPS = {
  KEY: 'propertyName',
}

function isTableConfig (context) {
  const keys = Object.values(TABLES_PROPS)
  return Object.keys(context.$attrs).some(key => keys.includes(key))
}

function getTableConfig (context) {
  const tables = context.$attrs[TABLES_PROPS.TABLES]
  const option = context.$attrs[TABLES_PROPS.OPTION]

  if (!(Array.isArray(tables) && tables.length > 0)) {
    return null
  }

  return tables.map(item => {
    return {
      [TAB_PROPS.GENERIC_ID]: option[item.searchCode],
      [TAB_PROPS.TYPE]: 'table',
      [TAB_PROPS.LABEL]: item.label || '字段设置',
      [TAB_PROPS.FIELDS]: cloneDeep(item[TABLES_PROPS.COLUMNS] || []),
      [TAB_PROPS.AUTH_URL]: item.option.authColunms ? item.url.method : '',
      [ORIGIN_FIELDS]: item[TABLES_PROPS.COLUMNS] || [],
    }
  })
}

function getFormConfig (context) {
  const form = context.$attrs[TABLES_PROPS.FORM_FIELDS] || {}
  const option = context.$attrs[TABLES_PROPS.OPTION]
  const fields = form[TABLES_PROPS.COLUMNS]
  if (!(Array.isArray(fields) && fields.length > 0)) {
    return null
  }

  return [
    {
      [TAB_PROPS.GENERIC_ID]: option[option.searchCode],
      [TAB_PROPS.TYPE]: 'form',
      [TAB_PROPS.LABEL]: option.label || '快捷查询设置',
      [TAB_PROPS.FIELDS]: cloneDeep(fields || []).map(item => ({
        ...item,
        [FIELD_PROPS.KEY]: item[FORM_PROPS.KEY]
      })),
      [ORIGIN_FIELDS]: fields || [],
    }
  ]
}

/**
 * 匹配转化表格配置为组件配置
 * @param {Object} context - Vue 组件实例
 * @param {Object} items - 组件配置
 */
export function normalizeConfig (context) {
  if (!isTableConfig(context)) {
    return null
  }

  const tableConfig = getTableConfig(context) || []
  const formConfig = getFormConfig(context) || []

  const normalizeItems = [
    ...tableConfig,
    ...formConfig
  ]
  return {
    items: normalizeItems
  }
}

/**
 * 更新组件配置
 * @param {Object} context - Vue 组件实例
 * @param {Object} params - 参数对象
 * @param {Object} params.item - 组件配置
 * @param {Number} params.index - 配置数据索引
 * @param {Array} params.newItem - 新配置数据 [{},{}]
 */
function updateConfigByType (context, { item, index, newItem }) {
  const tables = context.$attrs[TABLES_PROPS.TABLES]
  const form = context.$attrs[TABLES_PROPS.FORM_FIELDS] || {}

  if (item[TAB_PROPS.TYPE] === 'table') {
    tables[index][TABLES_PROPS.COLUMNS] = newItem
  } else {
    form[TABLES_PROPS.COLUMNS] = newItem
  }
}

/**
 * 更新组件配置
 * @param {Object} context - Vue 组件实例
 * @param {Object} params - 参数对象
 * @param {Object} params.item - 组件配置
 * @param {Number} params.index - 配置数据索引
 */
function updateConfig (context, item, index) {
  const fields = item[TAB_PROPS.FIELDS] || []
  const originalFields = item[ORIGIN_FIELDS] || []
  const isTable = item[TAB_PROPS.TYPE] === 'table'

  // 根据 fields 的顺序重新排序 originalFields
  const updatedColumns = fields.map(field => {
    const fieldKey = field[FIELD_PROPS.KEY]
    const matchedField = originalFields.find(f => (f[FIELD_PROPS.KEY] || f[FORM_PROPS.KEY]) === fieldKey)
    if (!matchedField) return null

    const fixed = field[INNER_FIELD_PROPS.FIXED] ? 'left' : ''
    return {
      ...matchedField,
      show: field[INNER_FIELD_PROPS.SHOW],
      fixed: isTable ? fixed : undefined,
    }
  }).filter(Boolean)

  updateConfigByType(context, { item, index, newItem: updatedColumns })
}


/**
 * 通过远端配置更新组件配置数据
 * @param {Object} context - Vue 组件实例
 * @param {Object} params - 参数对象
 * @param {Array} params.fieldContent - 原始配置数据 '[{},{}]'
 * @param {Array} params.jobTemplate - 岗位模版配置 '[string, string]'
 * @param {Number} params.index - 配置数据索引
 */
export function updateConfigByRemote (context, { fieldContent, jobTemplate, item, index }) {
  let fields = JSON.parse(fieldContent || '[]') || []
  fields = mergeFields(fields, jobTemplate)
  updateConfigByType(context, { item, index, newItem: fields })
}

/**
 * 将内部字段配置反向更新到原始 tables/form-fields 配置
 * @param {Object} context - Vue 组件实例
 * @param {Array} items - 内部配置数据
 */
export function updateConfigs (context, items) {
  if (!isTableConfig(context)) {
    return null
  }

  if (!Array.isArray(items) || items.length === 0) {
    return null
  }

  // 遍历内部配置，反向更新原始数据
  items.forEach((item, index) => {
    updateConfig(context, item, index)
  })
}



// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/data/normalize-table.js